import { render, staticRenderFns } from "./PlatformsEdit.vue?vue&type=template&id=2c6f0911&"
import script from "./PlatformsEdit.vue?vue&type=script&lang=ts&"
export * from "./PlatformsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports